"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageService = exports.browserTypes = exports.deviceTypes = void 0;
/* eslint-disable @typescript-eslint/ban-types */
var webexUI_1 = require("webexUI");
exports.deviceTypes = {
    iPhone: 'iPhone',
    iPad: 'iPad',
    android: 'android',
    desktop: 'desktop',
};
exports.browserTypes = {
    ie: 'ie',
    edge: 'edge',
    firefox: 'firefox',
    safari: 'safari',
};
var PageService = /** @class */ (function () {
    function PageService() {
        var _this = this;
        this.deviceType = exports.deviceTypes.desktop;
        this.browserType = null;
        this.onWindowResizeHandlers = [];
        this.onWindowResizeThrottleHandlers = [];
        this.onBodyClickHandlers = [];
        this.onPopStateHandlers = [];
        this.onScrollThrottleHandlers = [];
        this.onHashChangeHandlers = [];
        this.onPageLoadHandlers = [];
        this.onTouchStartHandlers = [];
        this.onTouchEndHandlers = [];
        this.ieClass = 'ie-active';
        this.edgeClass = 'edge-active';
        this.ffClass = 'ff-active';
        this.safariClass = 'safari-active';
        this.iPhoneClass = 'iphone-active';
        this.iPadClass = 'ipad-active';
        this.androidClass = 'android-active';
        this.touchStartHelper = function (event) {
            _this.onTouchStartHandlers.forEach(function (handler) {
                handler(event);
            });
        };
        this.touchEndHelper = function () {
            _this.onTouchEndHandlers.forEach(function (handler) {
                handler();
            });
        };
    }
    PageService.prototype.Init = function () {
        this.$window = $(window);
        this.$document = $(document);
        this.$body = $(document.body);
        this.DetectBrowser();
        this.DetectDeviceType();
    };
    PageService.prototype.AddOnHashChangeHandler = function (handler) {
        this.onHashChangeHandlers.push(handler);
    };
    PageService.prototype.AddOnPageLoadHandler = function (handler) {
        this.onPageLoadHandlers.push(handler);
    };
    PageService.prototype.AddOnWindowResizeHandler = function (handler) {
        this.onWindowResizeHandlers.push(handler);
    };
    PageService.prototype.AddOnWindowResizeThrottleHandler = function (handler) {
        this.onWindowResizeThrottleHandlers.push(handler);
    };
    PageService.prototype.AddOnBodyClickHandler = function (handler) {
        this.onBodyClickHandlers.push(handler);
    };
    PageService.prototype.AddOnScrollThrottleHandler = function (handler) {
        this.onScrollThrottleHandlers.push(handler);
    };
    PageService.prototype.AddOnTouchStartHandler = function (handler) {
        this.onTouchStartHandlers.push(handler);
    };
    PageService.prototype.AddOnTouchEndHandler = function (handler) {
        this.onTouchEndHandlers.push(handler);
    };
    PageService.prototype.AttachOnTouchStartHandler = function () {
        if (this.onTouchStartHandlers.length) {
            this.$document.on('touchstart', this.touchStartHelper);
        }
    };
    PageService.prototype.AttachOnTouchEndHandler = function () {
        if (this.onTouchEndHandlers.length) {
            this.$document.on('touchend', this.touchEndHelper);
        }
    };
    PageService.prototype.AttachOnScrollThrottleHandler = function () {
        var _this = this;
        if (this.onScrollThrottleHandlers.length) {
            this.$document.on('scroll', (0, webexUI_1.throttle)(function (e) {
                _this.ScrollThrottleHelper(e);
            }, 50));
        }
    };
    PageService.prototype.AttachOnHashChangeHandler = function () {
        if (this.onHashChangeHandlers.length) {
            this.$window.on('hashchange', this.hashChangeHelper.bind(this));
        }
    };
    PageService.prototype.AttachOnPageLoadHandler = function () {
        if (this.onPageLoadHandlers.length) {
            this.$window.on('load', this.pageLoadHelper.bind(this));
        }
    };
    PageService.prototype.AttachOnBodyClickHandlers = function () {
        this.onBodyClickHandlers.length && this.$body.on('click tap', this.BodyClickHelper.bind(this));
    };
    PageService.prototype.AddOnPopStateHandler = function (handler) {
        this.onPopStateHandlers.push(handler);
    };
    PageService.prototype.AttachOnPopStateHandlers = function () {
        var _this = this;
        if (this.onPopStateHandlers.length > 0) {
            window.onpopstate = function (event) {
                _this.onPopStateHandlers.forEach(function (handler) {
                    handler(event);
                });
            };
        }
    };
    PageService.prototype.AttachOnWindowResizeHandlers = function () {
        var _this = this;
        this.onWindowResizeHandlers.length &&
            this.$window.on('resize', (0, webexUI_1.debounce)(function () {
                _this.WindowResizeHelper();
            })) &&
            this.WindowResizeHelper();
    };
    PageService.prototype.AttachOnWindowResizeThrottleHandlers = function () {
        var _this = this;
        this.onWindowResizeThrottleHandlers.length &&
            this.$window.on('resize', (0, webexUI_1.throttle)(function () {
                _this.WindowResizeThrottleHelper();
            }));
    };
    PageService.prototype.DetectBrowser = function () {
        var ua = window.navigator.userAgent;
        // eslint-disable-next-line no-useless-escape
        var isIE = ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./);
        var isEdge = ua.indexOf('Edge') > -1;
        var isFF = ua.search('Firefox') > -1;
        var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        if (isIE) {
            this.$body.addClass(this.ieClass);
            this.browserType = exports.browserTypes.ie;
        }
        else if (isEdge) {
            this.$body.addClass(this.edgeClass);
            this.browserType = exports.browserTypes.edge;
        }
        else if (isFF) {
            this.$body.addClass(this.ffClass);
            this.browserType = exports.browserTypes.firefox;
        }
        else if (isSafari) {
            this.$body.addClass(this.safariClass);
            this.browserType = exports.browserTypes.safari;
        }
    };
    PageService.prototype.DetectDeviceType = function () {
        var ua = window.navigator.userAgent.toLowerCase();
        var isiPad = ua.indexOf('ipad') > -1;
        var isiPhone = ua.indexOf('iphone') > -1;
        var isAndroid = ua.indexOf('android') > -1;
        if (isiPad) {
            this.deviceType = exports.deviceTypes.iPad;
            this.$body.addClass(this.iPadClass);
        }
        else if (isiPhone) {
            this.deviceType = exports.deviceTypes.iPhone;
            this.$body.addClass(this.iPhoneClass);
        }
        else if (isAndroid) {
            this.deviceType = exports.deviceTypes.android;
            this.$body.addClass(this.androidClass);
        }
    };
    PageService.prototype.WindowResizeHelper = function () {
        var _this = this;
        this.windowWidth = this.$window.width();
        this.onWindowResizeHandlers.forEach(function (handler) {
            handler(_this.windowWidth);
        });
    };
    PageService.prototype.WindowResizeThrottleHelper = function () {
        var _this = this;
        this.windowWidth = this.$window.width();
        this.onWindowResizeThrottleHandlers.forEach(function (handler) {
            handler(_this.windowWidth);
        });
    };
    PageService.prototype.BodyClickHelper = function (event) {
        this.onBodyClickHandlers.forEach(function (handler) {
            handler(event);
        });
    };
    PageService.prototype.ScrollThrottleHelper = function (event) {
        this.onScrollThrottleHandlers.forEach(function (handler) {
            handler(event);
        });
    };
    PageService.prototype.hashChangeHelper = function (event) {
        this.onHashChangeHandlers.forEach(function (handler) {
            handler(event);
        });
    };
    PageService.prototype.pageLoadHelper = function () {
        this.onPageLoadHandlers.forEach(function (handler) {
            handler();
        });
    };
    return PageService;
}());
var service = new PageService();
exports.PageService = service;
